require("./transferStep1.scss");

// @vendors
const React = require("react");
const PropTypes = require("prop-types");
const { connect } = require("react-redux");
const { bindActionCreators } = require("redux");
const PureRenderMixin = require("react-addons-pure-render-mixin");
const classnames = require("classnames");

// @actions
const transferActions = require("actions/transferActions");
const offersActionsFunct = require("actions/offersActions");
import contractsActions from 'actions/contracts';

// @helpers
const {
    FormattedText,
    formatText,
    getLanguage,
    hasTranslation
} = require("core/i18n").i18n;
import { offersTransfersAdapter } from 'components/offers/adapters/transfersAdapter';

const { formatCurrency, formatAmount } = require("utilities/currencyHelper");
const { isSepa } = require("utilities/transfersHelper");
const { recordPath, PROC_START } = require("utilities/tagging");
const { changeBiocatchContext } = require("utilities/biocatch");
const { recordLinkV2 } = require("utilities/tagging");
// @components
const { OKCheckbox } = require("commonsComponents/OKCheckbox");
const OKSelect = require("components/commons/OKSelect/OKSelect");
const { OKMessage } = require("commonsComponents/OKMessage");
const InputCharsLeft = require("components/inputCharsLeft/inputCharsLeft");
const DatePickerCustom = require("components/datePickerCustom/datePickerCustom");
const DropdownAccounts = require("components/dropdownAccounts/dropdownAccounts");
const { AmountInput } = require("commonsComponents/amountInput");
import ContractErrorModal from '../../../../routes/contractsView/components/ContractErrorModal/contractErrorModal';
const {
    TransferEmitter
} = require("components/transfersSteps/transferSteps/transferStep1/transferEmitter/transferEmitter");
const Beneficiary = require("components/transfersSteps/transferSteps/transferStep1/beneficiary/beneficiary");
const TransactionRepetition = require("components/transactionRepetition/transactionRepetition");
const BeneficiaryEmailNotification = require("./beneficiaryEmailNotification/beneficiaryEmailNotification");
const { RadioButton } = require("commonsComponents/radioButton");
const { RadioButtonGroup } = require("commonsComponents/radioButtonGroup");
const {
    ImmediateBox
} = require("components/transfers/ImmediateBox/ImmediateBox");
const OKTooltip = require("components/commons/OKTooltip/OKTooltip");
const { OKLink } = require("commonsComponents/OKLink");
const OKModal = require('components/commons/OKModal/OKModal');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { ProductOffersModal } = require("./productOffers/productOffers");
const { selectTransferFieldsToShowModal } = require("./productOffers/offersSelector");

// @constants
const {
    BENEFICIARY_TYPE_NEW,
    BENEFICIARY_TYPE_EXISTING,
    EURO_TEXT,
    FIRST_STEP,
    TRANSFER_MIN_IMPORT,
    TRANSFER_MAX_IMPORT,
    TRANSFER_COSTS_BENEFICIARY,
    TRANSFER_COSTS_SENDER,
    TRANSFER_COSTS_SHARED,
    BENEFICIARY_TYPE_NGO,
    MODAL_MAX_LIMIT_EVENT,
    MODAL_MAX_LIMIT_ERROR
} = require("constants/index");
const {
    TRANSFERS_POPUP_25K_MORE,
} = require('constants/flagBasedFeatures');

const biocatch = require("constants/biocatch");
const {
    KNOWN_ACCOUNT_TRANSFER,
    NEW_BENEFICIARY_TRANSFER,
    ONG_TRANSFER
} = biocatch;

const beneficiaryTypeToContext = {
    Existing: KNOWN_ACCOUNT_TRANSFER,
    New: NEW_BENEFICIARY_TRANSFER,
    NGO: ONG_TRANSFER
};

const {
    DATE_PICKER_CUSTOM_PLACEHOLDER,
    DATE_PICKER_CUSTOM_DATE_FORMAT
} = require("constants/commonsComponents");

// @ Contact Center
const {
    CC_TRANSFER_TYPE_ORDINARY,
    CC_TRANSFER_TYPE_PAYROLL
} = require("constants/contactCenter/transfers");

const moment = require("moment");

class TransferStep1 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openModalImmediate: false,
            showOffersModal: false,
            amountTransfer: 0,
            fromIban: "",
            beneficiaryIban: "",
            currency: "",
            fromAccountOriginType: "",
            fromAccountOriginSubType: "",
            currencyAccountOrigin: "",
            newAmount: true,
            newBeneficiary: true,
            transferLimitModalStatus: false,
        };

        this.handleAccountFromChange = this.handleAccountFromChange.bind(this);
        this.buildCurrencyContent = this.buildCurrencyContent.bind(this);
        this.handleTransferCostsChange = this.handleTransferCostsChange.bind(
            this
        );
        this.handleChangeTransferType = this.handleChangeTransferType.bind(
            this
        );
        this.buildTransferTypesSection = this.buildTransferTypesSection.bind(
            this
        );
        this.buildTransferErrorMessage = this.buildTransferErrorMessage.bind(
            this
        );
        this.resetNecessaryFlows = this.resetNecessaryFlows.bind(
            this
        );
        this.handleToggleShowModal = this.handleToggleShowModal.bind(this);
        this.doTagging = this.doTagging.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(
            this
        );
        this.getProductOffers = this.getProductOffers.bind(this);
        this.handleProductOfferClick = this.handleProductOfferClick.bind(this);
        this.handleToggleOfferModal = this.handleToggleOfferModal.bind(this);
    }

    componentDidMount() {
        if (this.props.charity) {
            recordPath(
                window.location.pathname,
                "proc-transferencia-solidaria",
                PROC_START
            );
        }
    }
    componentWillUnmount(){
        this.handleToggleOfferModal()
    }
    componentDidUpdate(prevProps) {
        const { immBankEntity, immTransferState, immOffers, actions } = this.props;
        const step1 = immTransferState.getIn(["steps", FIRST_STEP]);
        const prevStep1 = prevProps.immTransferState.getIn(["steps", FIRST_STEP]);
        const currentBank = immBankEntity.get('bankName');
        const isFetchingBank = immBankEntity.get('isLoading');
        const prevBank = prevProps.immBankEntity.get('bankName');
        const prevCurrency = prevStep1.getIn(['beneficiary','new', 'currency']);
        const currency = step1.getIn(['beneficiary','new', 'currency']);
        const beneficiaryType = step1.getIn(["beneficiary", "type"]);
        const prevAmount = prevStep1.get('amount');
        const amount = step1.get('amount');
        const isEditingBeneficiary = step1.getIn(['beneficiary','new', 'isEditingBeneficiaryExisting']);
        const prevIsEditingBeneficiary = prevStep1.getIn(['beneficiary','new', 'isEditingBeneficiaryExisting']);
        const isNGOBeneficiaryType = step1.getIn(["beneficiary", "type"]) === BENEFICIARY_TYPE_NGO;
        const isAmountValid = step1.get('amountIsValid');
        const offersFetchData = immOffers.get('data').toJS();
        const originAccount = step1.get('fromAccount');
        const prevOriginAccount = prevStep1.get('fromAccount');
        const offersHasData = offersFetchData.offers && offersFetchData.offers.length > 0;
        let country = '';
        let prevCountry = '';
        let bankOptionName;
        let bankName;
        let prevBankName;
        let accountNumber;
        let isAccountNumberValid;
        let prevAccountNumber;
        let iban;
        let prevIban;
        let prevBic;
        let bic;
        let isBicValid;
        let isIbanValid;
        if (beneficiaryType === "New") {
            prevCountry = prevStep1.getIn(["beneficiary", "new", "country"]);
            country = step1.getIn(["beneficiary", "new", "country"]);
            bankName = step1.getIn(["beneficiary","new","bankName"]);
            prevBankName = prevStep1.getIn(["beneficiary","new","bankName"]);
            if (isSepa(country, currency)) {
                bankOptionName = '';
            }
            else {
                bankOptionName = step1.getIn(["beneficiary","new","bankOption"]) === "Name";
                prevAccountNumber = prevStep1.getIn(["beneficiary", "new", "accountNumber"]);
                accountNumber = step1.getIn(["beneficiary", "new", "accountNumber"]);
                isAccountNumberValid = step1.getIn(["beneficiary", "new", "accountNumberIsValid"]);
                isBicValid = step1.getIn(["beneficiary", "new", "bicIsValid"]);
                bic = step1.getIn(["beneficiary", "new", "bic"]);
                prevBic = prevStep1.getIn(["beneficiary", "new", "bic"]);
            }
        }
        if (beneficiaryType === "New" || isNGOBeneficiaryType) {
            if (isSepa(country, currency)) {
                iban = step1.getIn(["beneficiary", "new", "iban"]) || step1.getIn(["beneficiary", "new", "accountNumber"]);
                prevIban = prevStep1.getIn(["beneficiary", "new", "iban"]) || prevStep1.getIn(["beneficiary", "new", "accountNumber"]);
                isIbanValid = step1.getIn(["beneficiary", "new", "iban"])
                ? step1.getIn(["beneficiary", "new", "ibanIsValid"])
                : step1.getIn(["beneficiary", "new", "accountNumberIsValid"]);
            }
            else {
                iban = step1.getIn(["beneficiary", "new", "accountNumber"]);
                prevIban = prevStep1.getIn(["beneficiary", "new", "accountNumber"]);
                isIbanValid = step1.getIn(["beneficiary", "new", "accountNumberIsValid"]);
            }
        } else {
            iban = step1.getIn(["beneficiary", "existing", "iban"]) 
            || step1.getIn(["beneficiary", "existing", "accountNumber"])
            || step1.get('accountNumber');
            prevIban = prevStep1.getIn(["beneficiary", "existing", "iban"]) 
            || prevStep1.getIn(["beneficiary", "existing", "accountNumber"])
            || prevStep1.get('accountNumber');
            isIbanValid = true;
        }
        const shouldCallOffersInCC = __CONTACT_CENTER__ && (prevAmount !== amount || originAccount !== prevOriginAccount) && (amount !== 0 && originAccount !== '');
        if (
            ((prevBic !== bic) && !isBicValid)
            || ((iban !== prevIban) && !isIbanValid)
            || ((accountNumber !== prevAccountNumber) && !isAccountNumberValid)
            || ((prevAmount !== amount) && !isAmountValid)
            || (bankOptionName && (prevBankName !== bankName) && bankName === '')
        ) {
            actions.resetProductOffers();
        }
        if (shouldCallOffersInCC) {
            this.getProductOffers();
        } else if(!__CONTACT_CENTER__ && (prevAmount !== amount
            || ((currentBank !== prevBank) && !isFetchingBank)
            || (bankOptionName && (prevBankName !== bankName)) 
            || prevCurrency !== currency 
            || prevCountry !== country
            || (accountNumber !== prevAccountNumber)
            || ((isEditingBeneficiary !== prevIsEditingBeneficiary) && !isEditingBeneficiary))) {
            const bank = bankOptionName ? bankName : currentBank;
            this.getProductOffers(bank);
        }
        if(offersHasData){
            this.setState({showOffersModal: true})
        }
    }

    componentWillReceiveProps(nextProps) {
        const {
            amountTransfer,
            beneficiaryIban,
            newBeneficiary,
            newAmount
        } = this.state;
        const immFirstStep = nextProps.immTransferState.getIn(["steps", 0]);
        const beneficiaryIbanValue =
            immFirstStep.getIn(["beneficiary", "existing", "iban"]) !== ""
                ? immFirstStep.getIn(["beneficiary", "existing", "iban"])
                : immFirstStep.getIn(["beneficiary", "new", "iban"]);

        if (
            immFirstStep.get("amount") !== undefined &&
            immFirstStep.get("amount") !== amountTransfer &&
            newAmount
        ) {
            this.setState(
                {
                    amountTransfer: immFirstStep.get("amount"),
                    newAmount: false
                },
                () => {
                    this.isImmediateTransfer();
                }
            );
        }

        if (
            beneficiaryIbanValue &&
            beneficiaryIbanValue !== beneficiaryIban &&
            newBeneficiary
        ) {
            this.setState(
                {
                    beneficiaryIban: beneficiaryIbanValue,
                    newBeneficiary: false
                },
                () => {
                    this.isImmediateTransfer();
                }
            );
        }
        const beneficiaryType = immFirstStep.getIn(["beneficiary", "type"]);
        beneficiaryType &&
            changeBiocatchContext(beneficiaryTypeToContext[beneficiaryType]);
    }

    buildCurrencyContent() {
        const { immTransferState, immBeneficiaries } = this.props;
        const immFirstStep = immTransferState.getIn(["steps", 0]);
        const beneficiaryType = immFirstStep.getIn(["beneficiary", "type"]);
        let currencyText;

        if (beneficiaryType === BENEFICIARY_TYPE_NEW) {
            currencyText = immFirstStep.getIn([
                "beneficiary",
                "new",
                "currency"
            ]);
        } else {
            const beneficiaryExistingId = immFirstStep.getIn([
                "beneficiary",
                "existing",
                "id"
            ]);
            currencyText = beneficiaryExistingId
                ? immBeneficiaries.getIn([
                      "byId",
                      beneficiaryExistingId,
                      "currency"
                  ])
                : EURO_TEXT;
        }

        const currencySymbol = formatCurrency(currencyText);

        return (
            <div className="transfer-first-step__currency-symbol">
                {currencySymbol}
            </div>
        );
    }

    buildTransferTypes() {
        if (!__CONTACT_CENTER__) return null;

        const {
            immTransferState,
            actions,
            isTransferTypeChangeEnabled
        } = this.props;
        if (!isTransferTypeChangeEnabled()) {
            actions.handleChangeTransferType(CC_TRANSFER_TYPE_ORDINARY);
            return null;
        }

        const immFirstStep = immTransferState.getIn(["steps", FIRST_STEP]);

        return (
            <div className="transfer-first-step__transfer-types-container">
                <label
                    id="lbl_TransferStep1_TransferTypesTitle"
                    className="transfer-first-step__field-label"
                >
                    <FormattedText value="transferSummary-step1TransferTypesTitle" />
                </label>
                <RadioButtonGroup
                    name="transfer-types"
                    className="transfer-first-step__transfer-types"
                    idPrefix="transfer-types-radio"
                    selectedValue={immFirstStep.get("transferType")}
                    onChange={this.handleChangeTransferType}
                >
                    <RadioButton
                        key="transfer-first-step__transfer-type-ordinary"
                        label={formatText(
                            "transferSummary-step1TransferTypeOrdinary"
                        )}
                        value={CC_TRANSFER_TYPE_ORDINARY}
                    />
                    <RadioButton
                        key="transfer-first-step__transfer-type-payroll"
                        label={formatText(
                            "transferSummary-step1TransferTypePayroll"
                        )}
                        value={CC_TRANSFER_TYPE_PAYROLL}
                    />
                </RadioButtonGroup>
            </div>
        );
    }

    handleAccountFromChange(accountId, isInitialAccount = false) {
        const {
            actions: { setFromAccount },
            immAccounts
        } = this.props;

        this.isImmediateTransfer();

        if (accountId) {
            const immAccount = immAccounts.get(accountId);
            const immBalance = immAccounts.getIn([
                accountId,
                "balances",
                "availableBalance"
            ]);

            this.setState(
                {
                    fromAccountOriginType: immAccount.get("newProduct"),
                    fromAccountOriginSubType: immAccount.get("accountType"),
                    currencyAccountOrigin: immBalance.get("currency")
                },
                () => {
                    setFromAccount(
                        immBalance.get("amount"),
                        immBalance.get("currency"),
                        accountId,
                        isInitialAccount,
                        immAccount.get("iban"),
                        immAccount.get("accountType"), //cuentaOrigenSubtipoProducto
                        immAccount.get("newProduct") // cuentaOrigenTipoProducto
                    );
                    this.isImmediateTransfer();
                }
            );
        } else {
            setFromAccount();
        }
    }

    handleTransferCostsChange(costs) {
        const { actions } = this.props;
        if (actions) {
            const { handleTransferCostsChange } = actions;
            if (
                handleTransferCostsChange &&
                typeof handleTransferCostsChange === "function"
            ) {
                handleTransferCostsChange(costs.value);
            }
        }
    }

    handleChangeTransferType(value) {
        const { actions } = this.props;
        if (actions) {
            const { handleChangeTransferType } = actions;
            if (
                handleChangeTransferType &&
                typeof handleChangeTransferType === "function"
            ) {
                handleChangeTransferType(value);
                !__CONTACT_CENTER__ && this.getProductOffers();
            }
        }
    }

    resetNecessaryFlows() {
        const {
            actions: { resetImmediateTransfer, resetProductOffers }
        } = this.props;

        this.setState({ beneficiaryIban: "" }, () => {
            resetImmediateTransfer();
            resetProductOffers();
        });
    }

    isImmediateTransfer = () => {
        const {
            amountTransfer,
            beneficiaryIban,
            fromAccountOriginType,
            fromAccountOriginSubType,
            currencyAccountOrigin
        } = this.state;
        const { actions } = this.props;

        if (
            beneficiaryIban &&
            amountTransfer > 0 &&
            fromAccountOriginType &&
            fromAccountOriginSubType
        )
            actions.validateImmediateTransfer(
                beneficiaryIban,
                currencyAccountOrigin,
                amountTransfer,
                fromAccountOriginType,
                fromAccountOriginSubType
            );
    };

    handleOfferRedirection = (redirection) => {
        const { actions, history } = this.props;
        const { url, redirectionState } = redirection;
        redirectionState && actions.setRedirectionAccountState(redirectionState);
        url && history.push(url);
    }

    handleProductOfferClick = (offer) => {
        const { productId, redirection } = offer;
    
        if (offer.flowId === "DEPOSIT_HIRING_FLOW") {
            this.props.contractActions.setRenewalOrTransferToken(productId);
        } else if (offer.flowId === "ACCOUNT_LIMIT_FLOW") {
            this.props.actions.accountLimitModalToggle();
            this.handleToggleOfferModal();
        
        }
        this.handleOfferRedirection(redirection);
    }

    handleToggleOfferModal = ()=>{
        this.props.offersAstions.reset();
        this.setState({showOffersModal: false})
    }
    getProductOffers = (bankName = null) => {
        const {
            immAccounts,
            immTransferState,
            immBankEntity,
            immBeneficiaries,
            immFlagBasedFeatures,
            offersAstions
        } = this.props;
        const showOfferModal = selectTransferFieldsToShowModal({
            immAccounts: immAccounts,
            firstStepState: immTransferState.getIn(["steps", FIRST_STEP]),
            immBankEntity: immBankEntity,
            immBeneficiaries: immBeneficiaries,
            immFlagBasedFeatures: immFlagBasedFeatures
        });
        if(showOfferModal.showOffers){
            offersAstions.fetchOffers2({
                flow: 'TRANSFERS',
                metadata: showOfferModal.payload
            })
        }
    }

    callBackChangeAmount = amountTransfer => {
        const { actions, depositLimits, immFlagBasedFeatures } = this.props;
        const maxTransferLimit = +depositLimits.get('maxTransferLimit');
        if(amountTransfer > maxTransferLimit && immFlagBasedFeatures.get(TRANSFERS_POPUP_25K_MORE) && !__CONTACT_CENTER__)
        {   actions.setAmount(amountTransfer,maxTransferLimit);
            this.handleToggleShowModal('open')
        }
        else {
            recordLinkV2({
                categoriaEvento:"importe transferencia",
                accionEvento:"completado",
                amount: amountTransfer,
            });
            actions.setAmount(amountTransfer);
        }
        if (amountTransfer > 0) {
            this.setState(
                {
                    amountTransfer,
                    newAmount: false
                },
                () => {
                    this.isImmediateTransfer();
                }
            );
        }
    };
    doTagging(eventType){
    let etiquetaEvento ='';
    switch(eventType){
            case 'open':
                etiquetaEvento = "vista";
                break;
            case 'close':
                etiquetaEvento = "close"; 
                break;   
            case 'continue': 
                etiquetaEvento = "entendido";
                break;   
            default:
                    break;         
        }
        const analyticsData = {
            categoriaEvento: MODAL_MAX_LIMIT_EVENT,
            accionEvento: MODAL_MAX_LIMIT_ERROR,
            etiquetaEvento: etiquetaEvento
        }
        recordLinkV2(analyticsData);
    }

    handleToggleShowModal(eventType) {
        this.setState(previousState => ({
            transferLimitModalStatus: !previousState.transferLimitModalStatus
        }),this.doTagging(eventType));
    }

    changeIbanBeneficiary = beneficiaryIban => {
        this.setState(
            {
                beneficiaryIban,
                newBeneficiary: false
            },
            () => {
                this.isImmediateTransfer();
            }
        );
    };

    buildObligationMessage() {
        if (
            this.props.immTransferState.getIn([
                "steps",
                0,
                "beneficiary",
                "type"
            ]) === BENEFICIARY_TYPE_NGO
        ) {
            return (
                <OKMessage type="informative">
                    <FormattedText value="disclaimerPersonalInfo-solidarityTransferDisclaimer" />
                    &nbsp;
                    <OKLink
                        modifier={"emphasize"}
                        to={formatText("disclaimerPersonalInfo-urlGDPR")}
                        target="_blank"
                    >
                        <FormattedText value="disclaimerPersonalInfo-accountDirectDebitLinkText" />
                    </OKLink>
                </OKMessage>
            );
        } else {
            return null;
        }
    }

    buildTransferTypesSection() {
        const {
            immTransferState,
            actions,
            immediateTransfersEnabled
        } = this.props;

        const isImmediate = immTransferState.get("transferImmediate");
        const isImmediateFetching = immTransferState.get(
            "isFetchingTransferImmediate"
        );
        const isImmediateFailure = immTransferState.get(
            "failureTransferImmediate"
        );
        const doTransferImmediate = immTransferState.get("doTransferImmediate");
        const immediateAmount = formatAmount(
            immTransferState.get("transferImmediateAmount")
        );
        const currencySymbol = formatCurrency(
            immTransferState.getIn(["steps", 0, "fromAccountCurrency"])
        );

        return (
            <div className="transfer-first-step__form-section">
                <label className="transfer-first-step__type-transfer-title">
                    <FormattedText value="transferSummary-immediateTitle" />
                </label>
                <ImmediateBox
                    isImmediateFailure={isImmediateFailure}
                    isImmediateFetching={isImmediateFetching}
                    isImmediate={isImmediate}
                    immediateTransfersEnabled={immediateTransfersEnabled}
                    doTransferImmediate={doTransferImmediate}
                    immTransferState={immTransferState}
                    actions={actions}
                    immediateAmount={immediateAmount}
                    currencySymbol={currencySymbol}
                />
            </div>
        );
    }

    buildTransferErrorMessage() {
        const { immTransferState } = this.props;
        const immFirstStep = immTransferState.getIn(["steps", FIRST_STEP], {});
        const errorCode = immTransferState.getIn(["error", "error"], "");
        const errorDescription = immTransferState.getIn(
            ["error", "errorDescription"],
            ""
        );
        const errorCodeHasTranslation = hasTranslation(
            `transferSummary-${errorCode}`
        );
        const isInvalidForm =
            !immFirstStep.get("valid", true) || immTransferState.get("error");
        const mustShowError =
            immFirstStep.get("validationRan", false) && isInvalidForm;
        const regex = new RegExp(/[><]+/g);

        const errorTranslated = errorCodeHasTranslation ? (
            <FormattedText value={`transferSummary-${errorCode}`} />
        ) : (
            false
        );
        const errorNotTranslatedBackUp = (
            <FormattedText value="transferSummary-validationErrorMessage" />
        );

        return mustShowError ? (
            <OKMessage
                id="transfer-validation-fail-error-box"
                type="warning"
                allowHtml={!!errorDescription.match(regex)}
            >
                {errorTranslated ||
                    errorDescription ||
                    errorNotTranslatedBackUp}
            </OKMessage>
        ) : null;
    }

    getDepositLink() {
        let depositNavigationLink =  (
            <OKLink
                modifier="emphasize"
                onClick={() => this.props.redirectToDeposit(false)} 
                >
                <FormattedText value="transferSummary-maxLimitDepositNavigationLink" />
            </OKLink>
        );
    
        return (<FormattedTextWithComponents
            value="transferSummary-transferModalMaxLimitContent"
            injectedComponents={[depositNavigationLink]}
            />)
    }

    render() {
        const {
            immTransferState,
            immAccounts,
            immBankEntity,
            immBeneficiaries,
            immProfile,
            immOffers,
            accountsIndexes,
            initialAccountId,
            initialBeneficiaryId,
            transferPayerName,
            actions,
            immediateTransfersEnabled,
            isInactiveAccountsEnabled,
            depositLimits,
            immFlagBasedFeatures,
        } = this.props;

        const language = getLanguage();
        const obligatoryInformationSolidarity = this.buildObligationMessage();
        const isImmediate = immTransferState.get("transferImmediate");
        const currencyContent = this.buildCurrencyContent();
        const immFirstStep = immTransferState.getIn(["steps", FIRST_STEP]);
        const labelAmount = formatText("transferSummary-step1Amount");
        const labelFromAccount = formatText("transferSummary-step1Origin");
        const labelConcept = formatText("transferSummary-step1Concept");
        const labelTransferDate = immFirstStep.get("isEditingScheduled")
            ? formatText("transferSummary-step1DateScheduled")
            : formatText("transferSummary-step1DateOfIssue");

        const labelBeneficiary = formatText("transferSummary-step1Beneficiary");
        const tooltipMsgContent = isInactiveAccountsEnabled
            ? "inactiveAccounts-inactiveAccounts_dropdownCommonToolTip"
            : "";
        const maxTransferLimit = +depositLimits.get('maxTransferLimit');
        let limitCondition1= ((this.state.amountTransfer > maxTransferLimit) && immFlagBasedFeatures.get(TRANSFERS_POPUP_25K_MORE) && !__CONTACT_CENTER__);
        //Set the properties for dropdownAccounts component
        const fromAccountId = immFirstStep.get("fromAccount");
        let dropdownAccountsContent;

        /* fromAccount required message will be displayed if:
           there was user interaction (dirty),
           there is no fromAccount selected */
        const fromAccountRequiredAlertVisible =
            immFirstStep.get("fromAccountIsDirty") && fromAccountId === "";

        /* display fromAccount negativa balance will be displayed if:
           there was user interaction (dirty),
           there's a fromAccount selected,
           balance from selected account is not valid */
        const fromAccountNegativeBalanceAlertVisible =
            immFirstStep.get("fromAccountIsDirty") &&
            !immFirstStep.get("fromAccountIsValid");
        let fromAccountErrorMsg =
            formatText("transferSummary-step1FromAccountInvMsgFirstPart") +
            formatText("transferSummary-step1FromAccountInvMsgSecondPart");

        if (fromAccountRequiredAlertVisible) {
            fromAccountErrorMsg = formatText(
                "transferSummary-requiredMessageAlt",
                [labelFromAccount]
            );
        }

        const fromAccountIbanMatchAlertVisible = immFirstStep.get(
            "fromAccountIbanMatchBeneficiaryIban"
        );

        if (fromAccountIbanMatchAlertVisible) {
            fromAccountErrorMsg = formatText(
                "transferSummary-step1FromAccountIbanMatchBeneficiaryAccountIban"
            );
        }

        const amountAlert =
            immFirstStep.get("amountIsDirty") &&
            !immFirstStep.get("amountIsValid");
        /* amount zero alert message will be displayed if:
           there was user interaction (dirty),
           the amount field it's not valid because amount is zero */
        const amountZeroAlertVisible =
            amountAlert && immFirstStep.get("amount") === 0;
        let amountErrorMsg = formatText("transferSummary-step1ZeroAmount");

        /* amount excess alert message will be displayed if:
           there was user interaction (dirty),
           the field it's not valid because (fallback from previous variable),
           fromAccount negative balance alert is not visible */

       const amountExcessAlertVisible = !fromAccountNegativeBalanceAlertVisible &&
            amountAlert &&
            immFirstStep.get("amount") > 0;

            if(limitCondition1)
            {
            amountErrorMsg = formatText("transferSummary-step1AmountExcessTransferLimit")
            }else 
            if (amountExcessAlertVisible) {
            amountErrorMsg =
                formatText("transferSummary-step1AmountInvMsgFirstPart") +
                formatText("transferSummary-step1AmountInvMsgSecondPart");
            }

        //Set the limits for valid amounts
        const importMin = TRANSFER_MIN_IMPORT;
        const importMax = TRANSFER_MAX_IMPORT;
        const convertToMomentLocale = date =>
            moment.isMoment(date) &&
            date.locale &&
            date.locale(language || "es");

        const periodicityEnabled = immFirstStep.get("periodicityEnabled");
        const selectedDate = immFirstStep.get("date", moment());
        convertToMomentLocale(selectedDate);

        let outsideSepa;
        if (
            immFirstStep.getIn(["beneficiary", "type"]) ===
            BENEFICIARY_TYPE_EXISTING
        ) {
            const beneficiaryId = immFirstStep.getIn([
                "beneficiary",
                "existing",
                "id"
            ]);
            if (beneficiaryId) {
                const immBeneficiary = immBeneficiaries.getIn([
                    "byId",
                    beneficiaryId
                ]);
                outsideSepa = !isSepa(
                    immBeneficiary.get("country"),
                    immBeneficiary.get("currency")
                );
            }
        } else {
            outsideSepa = !isSepa(
                immFirstStep.getIn(["beneficiary", "new", "country"]),
                immFirstStep.getIn(["beneficiary", "new", "currency"])
            );
        }

        const transferTypes = this.buildTransferTypes();

        let transferCosts;

        if (outsideSepa) {
            const labelCosts = formatText("transferSummary-step1CostsTitle");
            const transferCostsOptions = [
                {
                    label: formatText(
                        "transferSummary-step1transferCostsBeneficiary"
                    ),
                    value: TRANSFER_COSTS_BENEFICIARY
                },
                {
                    label: formatText(
                        "transferSummary-step1transferCostsSender"
                    ),
                    value: TRANSFER_COSTS_SENDER
                },
                {
                    label: formatText(
                        "transferSummary-step1transferCostsShared"
                    ),
                    value: TRANSFER_COSTS_SHARED
                }
            ];
            transferCosts = (
                <div className="transfer-first-step__form-section">
                    <OKSelect
                        label={labelCosts}
                        name="issuing-company-filter"
                        onChange={this.handleTransferCostsChange}
                        options={transferCostsOptions}
                        value={immFirstStep.get("costs")}
                        searchable={false}
                        disabled={immFirstStep.get("isEditingScheduled")}
                    />
                </div>
            );
        }

        let transactionRepetition;

        if (periodicityEnabled) {
            changeBiocatchContext(biocatch.FREQUENT_BENEFICIARY_TRANSFER);
            transactionRepetition = (
                <TransactionRepetition
                    periodicityRange={immFirstStep.get("periodicityRange")}
                    periodicityType={immFirstStep.get("periodicityType")}
                    periodicityDate={immFirstStep.get("periodicityDate")}
                    periodicityCount={immFirstStep.get("periodicityCount")}
                    periodicityMinDate={immFirstStep.get("periodicityMinDate")}
                    periodicityCountIsInvalid={
                        !immFirstStep.get("periodicityCountIsValid")
                    }
                    periodicityTreatmentNonWorkableDay={immFirstStep.get(
                        "periodicityTreatmentNonWorkableDay"
                    )}
                    periodicityRangeQuantity={immFirstStep.get(
                        "periodicityRangeQuantity"
                    )}
                    periodicityRangeDescription={immFirstStep.get(
                        "periodicityRangeDescription"
                    )}
                    periodicityRangeSpecified={immFirstStep.get(
                        "periodicityRangeSpecified"
                    )}
                    selectedWeekDayIsInvalid={immFirstStep.get(
                        "selectedSingleWeekDayIsInvalid"
                    )}
                    customRepeatIsInvalid={immFirstStep.get(
                        "customRepeatIsInvalid"
                    )}
                    customSelectedMonthDays={immFirstStep.get(
                        "customSelectedMonthDays"
                    )}
                    customSelectedMonthDay={immFirstStep.get(
                        "customSelectedMonthDay"
                    )}
                    transferDate={selectedDate}
                    onTreatmentNonWorkableDay={
                        actions.handleTreatmentNonWorkableDay
                    }
                    onTypeChange={actions.handlePeriodicityType}
                    onRangeChange={actions.handlePeriodicityRange}
                    onDateChange={actions.handlePeriodicityDate}
                    onCountChange={actions.handlePeriodicityCount}
                    resetWeekDay={actions.resetSelectedWeekDay}
                    setWeekDay={actions.setWeekDay}
                    addCustomizedMonthDay={actions.addCustomizedMonthDay}
                    setPeriodicityRangeQuantity={
                        actions.setPeriodicityRangeQuantity
                    }
                    setCustomSelectedMonthDay={
                        actions.setCustomSelectedMonthDay
                    }
                    setPeriodicityRangeDescription={
                        actions.setPeriodicityRangeDescription
                    }
                    setPeriodicityRangeSpecification={
                        actions.setPeriodicityRangeSpecification
                    }
                    removeCustomizedMonthDay={actions.removeCustomizedMonthDay}
                    selectedWeekDay={immFirstStep.get("selectedWeekDay")}
                />
            );
        }

        if (accountsIndexes.length > 0) {
            dropdownAccountsContent = (
                <div id="sec_TransferStep1_AccountSelectContainer">
                    <DropdownAccounts
                        id="drd_TransferStep1_Origin"
                        label={labelFromAccount}
                        immAccounts={immAccounts}
                        accountsIndexes={accountsIndexes}
                        currentAccountId={fromAccountId}
                        initialAccountId={initialAccountId}
                        onAccountChange={this.handleAccountFromChange}
                        error={
                            fromAccountRequiredAlertVisible ||
                            fromAccountNegativeBalanceAlertVisible ||
                            fromAccountIbanMatchAlertVisible
                        }
                        errorMsg={fromAccountErrorMsg}
                        showAvailableBalance={true}
                        enabled={!immFirstStep.get("isEditingScheduled")}
                        tooltipMsg={tooltipMsgContent}
                        showInactiveAccountsAsBlocked={
                            isInactiveAccountsEnabled
                        }
                    />
                </div>
            );
        }

        const failValidationMsgContent = this.buildTransferErrorMessage();

        let emailContent;
        if (immFirstStep.get("isToday") && !periodicityEnabled) {
            emailContent = (
                <div className="transfer-first-step__form-section">
                    <h1 className="transfer-first-step__title--small">
                        <FormattedText value="transferSummary-step1BeneficiaryConfirmation" />
                    </h1>
                    <BeneficiaryEmailNotification
                        email={immFirstStep.getIn(["beneficiary", "email"])}
                        setEmailNotification={actions.setEmailNotification}
                    />
                </div>
            );
        }

        const beneficiaryLabelStyles = classnames(
            "transfer-first-step__field-label",
            {
                "transfer-first-step__field-label--hidden": immFirstStep.get(
                    "isReusingTransfer"
                )
            }
        );

        const periodicityNotAllowed =
            outsideSepa || immFirstStep.get("isEditingScheduled");
        const periodicityCheckbox = (
            <div className="transfer-first-step__periodicity">
                <OKCheckbox
                    idName="repeatInput"
                    disabled={periodicityNotAllowed}
                    value={periodicityEnabled}
                    onChange={actions.handlePeriodicityEnabled}
                    label={formatText("transferSummary-step1Repeat")}
                    extraClass="transfer-first-step__checkbox-periodicity"
                />
            </div>
        );

        let periodicityElement;
        if (periodicityNotAllowed) {
            const toolTipText = outsideSepa
                ? "transferSummary-periodicityTooltip"
                : periodicityEnabled
                ? "transferSummary-periodicalTransferNotAllowedIntoOneTime"
                : "transferSummary-puntualScheduledNotAllowedPeriodicity";

            periodicityElement = (
                <OKTooltip
                    content={toolTipText}
                    offset={[0, -10]}
                    target={periodicityCheckbox}
                />
            );
        } else {
            periodicityElement = periodicityCheckbox;
        }

        const isAllowedToChooseTransferTypes = immFirstStep.get(
            "isEditingScheduled"
        )
            ? false
            : isImmediate;

        let conceptContent;

        if (immTransferState.getIn(['steps', 0, 'beneficiary', 'type']) !== BENEFICIARY_TYPE_NGO) {
            conceptContent = (
                <div className="transfer-first-step__form-section">
                    <InputCharsLeft
                        callback={actions.setConcept}
                        id="inp_TransferStep1_Concept"
                        initialValue={immFirstStep.get("concept")}
                        label={labelConcept}
                        maxLength="100"
                    />
                </div>
            );
        }

        let transactionRepetitionTodayMessage;
        if(periodicityEnabled && immFirstStep.get("isToday")){
            transactionRepetitionTodayMessage = (
                <div className="transfer-first-step__today-periodicity-enabled-message">
                    <OKMessage type="informative">
                        <FormattedText value="transferDate-transferDate_todayPeriodicityEnabled" />
                    </OKMessage>
                </div>
            )
        }
    let transferLimitModal; 
    if(this.state.transferLimitModalStatus){
    const transferModalMaxLimitTitle = formatText("transferSummary-transferModalMaxLimitTitle");
    const transferModalMaxLimitContent = this.getDepositLink();
    const transferModalMaxLimitPrimaryButtonText = formatText('transferSummary-transferModalMaxLimitPrimaryButtonText');
   
    let modalContent1= (<p>{transferModalMaxLimitContent}</p>);

    
    transferLimitModal = limitCondition1 && (
        <OKModal
        content={modalContent1}
        isOpen={this.state.transferLimitModalStatus}
        onCloseCallback={() => this.handleToggleShowModal('close')}
        onPrimaryButtonClick={() =>this.handleToggleShowModal('continue')}
        primaryButtonText={transferModalMaxLimitPrimaryButtonText}
        title={transferModalMaxLimitTitle}
        footerType="action"
        />
        )
    }
    const offersFetchData = immOffers.get('data').toJS();
    const offersHasData = offersFetchData.offers && offersFetchData.offers.length > 0;
    const processedOffers = offersHasData ? offersTransfersAdapter(offersFetchData,{
        immFirstStep,
        immProfile,
        immFlagBasedFeatures,
    }) : null;
    const productOffersSection = !!processedOffers?.offers?.length ?
        <ProductOffersModal
            data={processedOffers}
            onCloseCallback={this.handleToggleOfferModal}
            onPrimaryButtonClick={this.handleToggleOfferModal}
            open={this.state.showOffersModal}
            onOfferClick={this.handleProductOfferClick}
            rawFetchData={offersFetchData}
            immFlagBasedFeatures={immFlagBasedFeatures}
        /> : null;
        return (
            <div className="transfer-first-step">
                <h1 className="transfer-first-step__title">
                    <FormattedText value="transferSummary-step1Title" />
                </h1>
                {failValidationMsgContent}
                <article className="transfer-first-step__content">
                    <form
                        id="frm_TransferStep1_Info"
                        className="transfer-first-step__form"
                    >
                        <div className="transfer-first-step__origin-account-section">
                            <div className="transfer-first-step__form-section">
                                {dropdownAccountsContent}
                            </div>
                            <TransferEmitter
                                immAccounts={immAccounts}
                                accountId={fromAccountId}
                                transferPayerName={transferPayerName}
                                emitter={immFirstStep.get("emitter")}
                                oldEmitter={immFirstStep.get("oldEmitter")}
                                setEmitter={actions.setEmitter}
                                loadOldEmitter={actions.loadOldEmitter}
                            />
                        </div>
                        <div className="transfer-first-step__form-section transfer-first-step__beneficiary-section">
                            <label
                                id="lbl_TransferStep1_Beneficiary"
                                className={beneficiaryLabelStyles}
                            >
                                {labelBeneficiary}
                            </label>
                            <Beneficiary
                                charity={this.props.charity}
                                immBankEntity={immBankEntity}
                                immBeneficiaries={immBeneficiaries}
                                initialBeneficiaryId={initialBeneficiaryId}
                                immBeneficiary={immFirstStep.get("beneficiary")}
                                actions={actions}
                                changeBeneficiary={
                                    this.resetNecessaryFlows
                                }
                                changeIbanBeneficiary={
                                    this.changeIbanBeneficiary
                                }
                                isEditingScheduled={immFirstStep.get(
                                    "isEditingScheduled"
                                )}
                                isReusingTransfer={immFirstStep.get(
                                    "isReusingTransfer"
                                )}
                                getProductOffers={this.getProductOffers}
                            />
                        </div>
                        <div className="transfer-first-step__form-section">
                            <div className="transfer-first-step__amount">
                                <AmountInput
                                    id="inp_TransferStep1_Amount"
                                    label={labelAmount}
                                    callback={this.callBackChangeAmount}
                                    min={importMin}
                                    max={importMax}
                                    error={
                                        amountZeroAlertVisible ||
                                        amountExcessAlertVisible
                                    }
                                    errorMsg={amountErrorMsg}
                                    amount={immFirstStep.get("amount")}
                                    showBlurZero
                                    hideFocusZero
                                    disablePaste
                                    language={language}
                                />
                            </div>
                            {currencyContent}
                        </div>
                        {productOffersSection}
                        {transferTypes}
                        {isAllowedToChooseTransferTypes &&
                            !periodicityEnabled &&
                            isImmediate &&
                            !!immediateTransfersEnabled &&
                            this.buildTransferTypesSection()}
                        {transferCosts}
                        {conceptContent}
                        {!immTransferState.get("doTransferImmediate") && (
                            <div className="transfer-first-step__form-section">
                                <div className="transfer-first-step__date">
                                    <DatePickerCustom
                                        label={labelTransferDate}
                                        callback={actions.setDate}
                                        selectedDate={selectedDate}
                                        minDate={immFirstStep.get("minDate")}
                                        locale={language}
                                        placeholder={formatText(
                                            DATE_PICKER_CUSTOM_PLACEHOLDER
                                        )}
                                        dateFormat={formatText(
                                            DATE_PICKER_CUSTOM_DATE_FORMAT
                                        )}
                                        newSelectedDate={selectedDate}
                                        allowEmptyDate
                                    />
                                </div>
                                {periodicityElement}
                            </div>
                        )}
                        {immTransferState.get("doTransferImmediate") && (
                            <OKMessage type="informative">
                                <FormattedText value="transferSummary-immediateInformationDate" />
                            </OKMessage>
                        )}
                        {transactionRepetitionTodayMessage}
                        {transactionRepetition}
                        {emailContent}
                        {obligatoryInformationSolidarity}
                    </form>
                </article>
                {transferLimitModal}
                <ContractErrorModal 
                    title={formatText("transferSummary-step1AccountLimitTitle")}
                    description={<FormattedText value={"transferSummary-step1AccountLimitDescription"} />}
                    onSubmit={() => actions.accountLimitModalToggle()}
                    hasCloseButton
                    showModal={immFirstStep.get("showAccountLimitReachedModal")}
                />
            </div>
        );
    }
}

TransferStep1.propTypes = {
    accountsIndexes: PropTypes.array,
    actions: PropTypes.object,
    immAccounts: PropTypes.object,
    immBankEntity: PropTypes.object,
    immBeneficiaries: PropTypes.object,
    immProfile: PropTypes.object,
    immOffers: PropTypes.object,
    originCountry: PropTypes.string,
    initialAccountId: PropTypes.string,
    initialBeneficiaryId: PropTypes.string,
    immTransferState: PropTypes.object,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    transferPayerName: PropTypes.string,
    charity: PropTypes.string,
    immediateTransfersEnabled: PropTypes.bool,
    isTransferTypeChangeEnabled: PropTypes.func,
    depositLimits: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    redirectToDeposit: PropTypes.func,
    clientFirstName: PropTypes.string,
    scheduledId: PropTypes.string,
};

module.exports.constructor = TransferStep1;
module.exports.TransferStep1 = connect(null, dispatch => ({
    actions: bindActionCreators(transferActions, dispatch),
    offersAstions: bindActionCreators(offersActionsFunct, dispatch),
    contractActions: bindActionCreators(contractsActions, dispatch),
}))(TransferStep1);
